export default "/cars-for-sale/inventory/:vin([A-HJ-NPR-Z0-9]{17})?/:seoListingId([0-9]{5,})?";